import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/index'
import axios from './plugins/axios'
import Dashboard from './view/Dashboard.vue'
import Usuarios from './view/Usuarios.vue'
import Nivel from './view/Nivel.vue'
import Permissao from './view/Permissao.vue'
import Tarefas from './view/Tarefas.vue'
import TarefasAgente from './view/TarefasAgente.vue'
import Denuncias from './view/Denuncia.vue'
import Roteiros from './view/Roteiros.vue'
import login from './view/login.vue'
import Perfil from './view/Perfil.vue'
import Empresa from './view/Empresa.vue'
import Solicitacoes from './view/Solicitacoes'
import SolicitacoesAgente from './view/SolicitacoesAgente'
import MapaEmpresas from './view/MapaEmpresas'
import MapaLicencas from './view/MapaLicencas'
import MapaFiscais from './view/MapaFiscais'
import MapaFiscaisEmTempoReal from './view/MapaFiscalTempoReal'
import RelatorioTarefa from './view/RelatorioTarefa'
import LogSistema from './view/LogSistema'

Vue.use(Router)

/*
  Verifica se o usuário esta autenticado e o token é valido. Caso esteja, renderiza a pagina destino
  caso não esteja autenticado ou o token seja invalido, renderiza a pagina de login e apaga o token do localStorage
  se tentar acessar /login autenticado e com token valido, é redirecionado para a pagina "/" (Home).
*/
const ifAuthenticatedRenderPageElseRenderLogin = async (to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    try {
      await axios.post("/verifyToken", null, {
        headers: {
          "x-auth-token": store.getters.token
        }
      })

      next()
    } catch (error) {
      store.dispatch("setToken", "")
      store.dispatch("setAuthenticatedState", false)

      next("/login")
    }
  } else {
    next();
  }
}

/*
  Se o usuário estiver autenticado, o componente de login não é renderizado. É redirecionado
  para a Home "/".
*/
const doNotRenderLoginIfAuthenticated = (to, from, next) => {
  if (store.getters.isAuthenticated) {
    next({
      path: '/'
    })
  } else {
    next()
  }
}


//Toda rota do aplicativo será registrada aqui.
const router = new Router({
  mode: 'history',
  history: true,
  routes: [
    {
      path: '/',
      name: "Dashboard",
      component: Dashboard,
      meta: { requiresAuth: true }
    },

    {
      path: '/empresa',
      name: 'Emppresa',
      component: Empresa,
      meta: { requiresAuth: true }
    },
    {
      path: '/solicitacoes',
      name: 'Solicitações',
      component: Solicitacoes,
      meta: { requiresAuth: true }
    },
    {
      path: '/solicitacoesAgente',
      name: 'SolicitaçõesAgente',
      component: SolicitacoesAgente,
      meta: { requiresAuth: true }
    },
    {
      path: '/roteiros',
      name: 'Roteiros',
      component: Roteiros,
      meta: { requiresAuth: true }
    },
    {
      path: '/usuarios',
      name: 'Usuarios',
      component: Usuarios,
      meta: { requiresAuth: true }
    },

    {
      path: '/nivel',
      name: 'Nivel',
      component: Nivel,
      meta: { requiresAuth: true }
    },

    {
      path: '/permissao',
      name: 'Permissao',
      component: Permissao,
      meta: { requiresAuth: true }
    },

    {
      path: "/login",
      name: "login",
      component: login,
      beforeEnter: doNotRenderLoginIfAuthenticated
    },

    {
      path: "/perfil",
      name: "Perfil",
      component: Perfil,
      meta: { requiresAuth: true }
    },

    {
      path: "/tarefas",
      name: "Tarefas",
      component: Tarefas,
      meta: { requiresAuth: true }
    },
    {
      path: "/tarefasAgente",
      name: "Tarefas Usuário",
      component: TarefasAgente,
      meta: { requiresAuth: true }
    },
    {
      path: "/denuncias",
      name: "Denuncias",
      component: Denuncias,
      meta: { requiresAuth: true }
    },
    {
      path: "/mapaEmpresas",
      name: "Mapa de Empresas",
      component: MapaEmpresas,
      meta: { requiresAuth: true }
    },
    {
      path: "/mapaLicencas",
      name: "Mapa de Licenças",
      component: MapaLicencas,
      meta: { requiresAuth: true }
    },
    {
      path: "/mapaFiscais",
      name: "Mapa de Fiscais",
      component: MapaFiscais,
      meta: { requiresAuth: true }
    },
    {
      path: "/mapaFiscaisEmTempoReal",
      name: "Mapa de Fiscais Em Tempo Real",
      component: MapaFiscaisEmTempoReal,
      meta: { requiresAuth: true }
    },
    {
      path: "/relatorioTarefas",
      name: "Relatorio de Tarefas",
      component: RelatorioTarefa,
      meta: { requiresAuth: true }
    },
    {
      path: "/logSistema",
      name: "Log Sistema",
      component: LogSistema,
      meta: { requiresAuth: true }
    },
  ]
});

router.beforeEach(ifAuthenticatedRenderPageElseRenderLogin);

export default router;